import { render, staticRenderFns } from "./UpdateOrderPopup.vue?vue&type=template&id=51daa71c"
import script from "./UpdateOrderPopup.vue?vue&type=script&lang=js"
export * from "./UpdateOrderPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports